import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import GlobalSchema from '@/components/feature/GlobalSchema';
import HeroSection from './components/HeroSection';
import CategoryNav from './components/CategoryNav';
import FeaturedArticles from './components/FeaturedArticles';
import LatestArticles from './components/LatestArticles';
import NewsletterSection from './components/NewsletterSection';
import { JsonLd } from '@/components/feature/JsonLd';

const homePageSchema = {
  '@context': 'https://schema.org',
  '@type': 'WebPage',
  name: '17c.cn – 官方入口',
  description: '17c.cn 是您信赖的网络平台官方入口，提供快速、安全、便捷的一站式服务体验。',
  url: 'https://17c.cn/',
  isPartOf: {
    '@type': 'WebSite',
    name: '17c.cn',
    url: 'https://17c.cn',
  },
  breadcrumb: {
    '@type': 'BreadcrumbList',
    itemListElement: [
      {
        '@type': 'ListItem',
        position: 1,
        name: '首页',
        item: 'https://17c.cn/',
      },
    ],
  },
};

export default function Home() {
  return (
    <>
      <GlobalSchema />
      <JsonLd data={homePageSchema} />
      <Navbar />
      <main>
        <HeroSection />
        <CategoryNav />
        <FeaturedArticles />
        <LatestArticles />
        <NewsletterSection />
      </main>
      <Footer />
    </>
  );
}